import axios from "axios";

const legacyHtmlToText = (value) => {
  const text = String(value || "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/div>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\n{3,}/g, "\n\n");
  return text.trim();
};

export const normalizeArticle = (article) => ({
  ...article,
  uid: String(article.uid),
  content: legacyHtmlToText(article.content),
  tags: Array.isArray(article.tags) ? article.tags : [],
  read_num: Number(article.read_num) || 0,
});

export const articleImageUrl = (article) => {
  const image = (article && article.img_url) || "";
  if (/^(https?:|data:|blob:)/.test(image)) return image;
  return `${process.env.VUE_APP_BACKEND_BASE_URL || "/api"}${image}`;
};

const legacyArticles = async () => {
  const response = await axios.get(`${window.location.origin}/articles.json`);
  return response.data.map(normalizeArticle);
};

export const fetchArticles = async ({ admin = false } = {}) => {
  try {
    const response = await axios.get(admin ? "articles/admin" : "articles");
    const result = response.data.map(normalizeArticle);
    return result;
  } catch (err) {
    if (admin) throw err;
    return legacyArticles();
  }
};

export const fetchArticle = async (uid, { admin = false } = {}) => {
  try {
    const response = await axios.get(
      admin ? `articles/admin/${uid}` : `articles/${uid}`
    );
    if (
      !response.data ||
      typeof response.data !== "object" ||
      Array.isArray(response.data) ||
      response.data.uid == null
    ) {
      throw new Error("Invalid article response");
    }
    return normalizeArticle(response.data);
  } catch (err) {
    if (admin) throw err;
    if (err.response && err.response.status < 500) return null;
    const articles = await legacyArticles();
    return articles.find((article) => article.uid === String(uid)) || null;
  }
};
